import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button, Col } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import { NavLink } from "react-router-dom";
import { Referral_cashback_get } from "../../../../store/actions/SuperAdminActions/SuperAdminReferralCashbackAction";
import PropTypes from "prop-types";
import { MenuItem, Menu } from "@material-ui/core";
import { connect } from "react-redux";
import { REFERRAL_PROGRAM_TYPES } from "./../../../../enums/OrderEnums";
import moment from "moment";
import BasicPagination from "../../../Pagination/Pagination";
import isEmpty from "../../../../store/validation/is-Empty";
import SuperAdminDeleteReferral from "./SuperAdminDeleteReferral";
import { Form } from "react-bootstrap";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import { SmallLoader } from "../../../Loader/SmallLoader";
import ViewReferralDetails from "./ViewReferralDetails";
function SuperAdminReferralRewarddashboard(props) {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showView, setShowView] = useState(false);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });
  const onSuccess = () => {
    setLoading(false);
  };
  const [showsearch, setShowSearch] = useState(false);
  const [referralData, setReferralData] = useState([]);
  const [status, setStatus] = useState("All");
  const [Activitype, setActivitype] = useState("All");
  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
    userWalletTransactionTypeText: "All",
  });

  const statusTypes = [
    { id: 0, title: "All" },
    { id: 1, title: "pending" },
    { id: 2, title: "validated" },
    { id: 3, title: "rejected" },
    { id: 4, title: "success" },
  ];

  const ActivityTypes = [
    { id: 0, title: "All" },
    { id: 1, title: "With Qualifying Activity" },
    { id: 2, title: "With Registration Activity" },
  ];

  const handleCloseView = () => setShowView(false);
  const [data, setData] = useState();
  const handleShowView = (dataForModal) => {
    setData(dataForModal);
    setShowView(true);
  };
  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  const getData = () => {
    props.Referral_cashback_get(
      props.auth.user.accessToken,
      dateQuery,
      onSuccess
    );
  };

  useEffect(
    (async) => {
      const DateForm = {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      };
      if (!isEmpty(dateQuery)) {
        setLoading(true);
        getData(
          props.auth.user.accessToken,
          dateQuery.startDate === "undefined" ? DateForm : dateQuery
        );
      }
    },
    [dateQuery]
  );

  // useEffect(() => {
  //   const token = props.auth.user.accessToken;
  //   props.Referral_cashback_get(token);
  // }, []);

  let filteredData = [];
  const referralDataArr = referralData && referralData;
  filteredData = referralDataArr;

  const countActiveReferrals = () => {
    let activeCount = 0;
    for (let i = 0; i < props.data.length; i++) {
      if (props.data[i]) {
        activeCount += 1;
      }
    }
    return activeCount;
  };

  useEffect(() => {
    if (!isEmpty(props.data)) {
      setReferralData(props.data);
    }
  }, [props.data]);

  //filter button actions //

  const [showFilter, setShowFilter] = useState(false);

  const sortopts = [
    { title: "Referral program", disabled: true },
    { title: `A-Z`, disabled: false },
    { title: "Z-A", disabled: false },
  ];

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const searchClick = () => {
    setShowFilter(!showFilter);
  };
  const cancelClick = () => {
    setShowFilter(!showFilter);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const RenderTableBody = () => {
    if (state.search) {
      filteredData = referralDataArr.filter((getall) => {
        return (
          getall?.referral_program_id.toString().includes(state.search) ||
          getall?.programName
            ?.toLowerCase()
            ?.includes(state.search?.toLowerCase())
        );
      });
    }

    if (status) {
      filteredData = filteredData.filter((item) => {
        if (status === "pending") {
          return item?.status === "PENDING";
        } else if (status === "validated") {
          return item?.status === "VALIDATED";
        } else if (status === "rejected") {
          return item?.status === "REJECTED";
        } else if (status === "success") {
          return item?.status === "SUCCESS";
        } else {
          return item;
        }
      });
    }
    if (Activitype) {
      filteredData = filteredData.filter((item) => {
        if (Activitype === "With Qualifying Activity") {
          return item?.referral_activity_type === 1;
        } else if (Activitype === "With Registration Activity") {
          return item?.referral_activity_type === 0;
        } else {
          return item;
        }
      });
    }
    if (sort === "A-Z") {
      filteredData = filteredData.sort((a, b) => {
        if (a.programName < b.programName) return -1;
        if (a.programName > b.programName) return 1;
        return 0;
      });
    } else if (sort === "Z-A") {
      filteredData = filteredData.sort((a, b) => {
        if (a.programName < b.programName) return 1;
        if (a.programName > b.programName) return -1;
        return 0;
      });
    }

    return (
      <React.Fragment>
        {loading ? (
          <SmallLoader />
        ) : (
          <>
            {filteredData.slice(start, end).map((ele, index) => (
              <TableBody
                key={index}
                data={ele}
                handleShowView={handleShowView}
              />
            ))}
          </>
        )}
      </React.Fragment>
    );
  };

  //download button//
  const downloadData = {
    headers: [
      { label: "Referral  \n Program ID", key: "prog_id" },
      { label: "Referral Program Name", key: "prog_name" },
      { label: "Referral Program Category", key: "Category" },
      { label: "Validity", key: "validity" },
      { label: "Referral Activity Type", key: "activity" },
      { label: "Referral Amount Details", key: "amount" },
      { label: "Status", key: "status" },
      { label: "country,state,city", key: "place" },
    ],
    data: filteredData
      ? filteredData?.map((ele) => {
          return {
            prog_id: ele?.referral_program_id,
            prog_name: ele?.programName,
            Category: `${REFERRAL_PROGRAM_TYPES.map((data, index) => {
              return data?.value === ele?.referral_type ? data?.name : "";
            })}`,
            validity: `${moment(props?.ele?.start_date).format(
              "Do MMM YYYY"
            )} - ${moment(props?.ele?.start_date).format(
              "hh:mm A"
            )} \n ${moment(props?.ele?.end_date).format(
              "Do MMM YYYY"
            )} -   ${moment(props?.ele?.end_date).format("hh:mm A")}`,
            activity: "With Registration Activity",
            amount: `Referrer: ₹ ${ele?.referrer_amount || 0} \n
                        Referee: ₹ ${ele?.referee_amount || 0} \n 
                        Udbhav: ₹ ${ele?.udbhav_amount || 0}`,
            status: ele?.status || " ",
            place: `${ele?.country} , ${ele?.state} ,${ele?.city}`,
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Referral Program Dashboard
                  <br />
                </div>
                <div className="col-6 text-right">
                  {/* <button
                    type="button"
                    class="mr-4 px-5 py-2 btn addBtnRed f12-700"
                    style={{color:'#EE3A23'}}
                    >
                  
                 </button> */}
                  <NavLink
                    to="/SuperAdminReferralRewarddashboard/AddReferralProgram"
                    className="mr-4 px-5 py-2 btn addBtnRed f12-700"
                    style={{ color: "#f26856" }}
                  >
                    Add Referral Program
                  </NavLink>
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex">
                  <Image
                    onClick={() => setShowSearch(!showsearch)}
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    onClick={handleShowFilter}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                  </div>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {sortopts.map((ele, index) => {
                      return (
                        <MenuItem
                          value={ele.title}
                          key={index}
                          onClick={() => setSort(ele.title)}
                          disabled={ele.disabled}
                        >
                          {ele.title}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                  <CSVDownloader
                    filename={"Referral, Rewards & Cash back"}
                    headers={downloadData.headers}
                    data={downloadData.data}
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    {/* <SelectFilter onDateChange={onDateChangeHandler} /> */}
                  </div>
                </div>
                <div className="col-2"></div>
              </div>
              {showsearch && (
                <>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    name="search"
                    onChange={onSearchChange}
                    value={state.search}
                    className="amSearch"
                  />
                </>
              )}
              {showFilter && (
                <div className="col-12  mt-3">
                  <div className="enWhiteBox mt-3">
                    <Form className="row justify-content-between">
                      <Col md={5}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Offer">
                              Status
                            </InputLabel>
                            <Select
                              value={status}
                              onChange={(e) => setStatus(e.target.value)}
                              label="status"
                              inputProps={{
                                name: "status",
                                id: "outlined-Location",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {statusTypes.map((data) => {
                                return (
                                  <option value={data.title} key={data.id}>
                                    {data.title}
                                  </option>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Offer">
                              Referral Activity Type
                            </InputLabel>
                            <Select
                              value={Activitype}
                              onChange={(e) => setActivitype(e.target.value)}
                              label="Activity type"
                              inputProps={{
                                name: "status",
                                id: "outlined-Location",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {ActivityTypes.map((data) => {
                                return (
                                  <option value={data.title} key={data.id}>
                                    {data.title}
                                  </option>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                      <div className="d-flex align-items-center mt-4 ml-4">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5"
                          onClick={cancelClick}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5"
                          onClick={searchClick}
                        >
                          Apply Filter
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              )}
              <hr />
              <div>
                <div
                  className="d-flex  mt-3 mb-3"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Total Cash back",
                        // loader: props.auth.secondary_loader,
                        value: 0,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Total Rewards",
                        //  loader: props.auth.secondary_loader,
                        value: 0,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total Referral Program",
                        //  loader: props.auth.secondary_loader,
                        value: countActiveReferrals(),
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>

              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main mt-2">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        Referral <br /> Program ID
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Referral <br />
                        Program Name
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Referral Program <br />
                        Category (From & To)
                      </td>

                      <td style={{ width: "15%" }} className="f12-400">
                        Validity
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Referral Activity <br /> Type
                      </td>
                      <td style={{ width: "12%" }} className="f12-400">
                        Referral
                        <br />
                        Amount Details
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Status
                      </td>
                    </tr>
                  </thead>
                  {RenderTableBody()}
                  {/* {filteredData &&
                    filteredData.map((ele, index) => (
                      <TableBody data={ele} key={index} />
                    ))} */}
                </Table>
              </div>
              <div className="p4v2-menu-pagination">
                {props.data && props.data.length !== 0 ? (
                  <BasicPagination
                    totalRecords={props?.filteredData?.length || 0}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ViewReferralDetails
        onClickCloseView={handleCloseView}
        onClickshowView={showView}
        data={data}
      />
    </React.Fragment>
  );
}

const TableBody = ({ handleShowView, data }) => {
  let ele = data;
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  // console.log(ele, "dataaaaaaa");
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row pl-1" onClick={showTr}>
                <td style={{ width: "15%" }}>
                  <div>
                    <h5 className="font_16_m mt-3">
                      #{ele?.referral_program_id}
                    </h5>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <h3 className="font_20_m">{ele?.programName}</h3>
                </td>
                <td style={{ width: "15%" }}>
                  <h3 className="font_20_m">
                    {REFERRAL_PROGRAM_TYPES &&
                      REFERRAL_PROGRAM_TYPES.map((data, index) => {
                        return data?.value === ele?.referral_type
                          ? data?.name
                          : "";
                      })}
                  </h3>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-400">
                    {" "}
                    {moment(ele && ele.start_date).format("Do MMM YY,")}{" "}
                    {moment(ele?.start_date).format("hh:mm:A")}
                  </div>
                  <div className="f12-400 text-red">
                    {moment(ele && ele.end_date).format("Do MMM YY,")}{" "}
                    {moment(ele?.end_date).format("hh:mm:A")}
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500">
                    {/* {ele?.referral_activity_type === 1
                      ? "With Registration Activity"
                      : "With Qualifying Activity"} */}
                    With Registration
                    <br /> Activity
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    {" "}
                    Referrer: ₹ {ele?.referrer_amount} <br />
                    Referee: ₹{ele?.referee_amount} <br />
                    Udbhav: ₹{ele?.udbhav_amount}
                  </div>
                </td>
                <td style={{ width: "10%", paddingLeft: "1.5rem" }}>
                  {ele?.status === "VALIDATED" ? (
                    <div
                      className="badge badge-success px-3 py-2"
                      style={{ borderRadius: "20px" }}
                    >
                      validated
                    </div>
                  ) : ele?.status === "PENDING" ? (
                    <div
                      className="badge badge-warning px-3 py-2"
                      style={{ borderRadius: "20px" }}
                    >
                      pending
                    </div>
                  ) : ele?.status === "REJECTED" ? (
                    <div
                      className="badge badge-danger px-3 py-2"
                      style={{ borderRadius: "20px" }}
                    >
                      rejected
                    </div>
                  ) : ele?.status === "CANCELLED" ? (
                    <div
                      className="badge badge-danger px-3 py-2"
                      style={{ borderRadius: "20px" }}
                    >
                      cancelled
                    </div>
                  ): (
                    <div
                      className="badge badge-success px-3 py-2"
                      style={{ borderRadius: "20px" }}
                    >
                      success
                    </div>
                  )}
                </td>
              </tr>
              {TrDetail && (
                <>
                  <tr className="sd_accordion_body">
                    <td style={{ width: "20%" }}>
                      <div className="f14-400 mb-2">More details</div>
                      <div className="d-flex">
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={() => handleShowView(ele)}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/eye.svg")}
                            alt="View offer"
                            title="View offer"
                            fluid
                          />
                        </Button>
                        <NavLink
                          className="enIconBtn mr-3"
                          to={`/SuperAdminReferralRewarddashboard/edit-referral-reward-request/${ele?._id}`}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit req"
                            title="Edit referral"
                            fluid
                          />
                        </NavLink>
                        <SuperAdminDeleteReferral refId={ele?._id} />
                      </div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div className="f14-400 mb-2">Country</div>
                      <div className="f14-500 mb-2">{ele?.country}</div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div className="f14-400 mb-2">state</div>
                      <div className="f14-500 mb-2">{ele?.state}</div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div className="f14-400 mb-2">city</div>
                      <div className="f14-500 mb-2">{ele?.city}</div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

// export default SuperAdminReferralRewarddashboard;

SuperAdminReferralRewarddashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  data: state.superAdminReferrals.referralRewardAndCashback,
});

export default connect(mapStateToProps, {
  Referral_cashback_get,
})(SuperAdminReferralRewarddashboard);
